<template>
  <v-list three-line>
    <template v-for="(item, index) in items">
      <v-divider :key="index" v-if="index > 0" />
      <v-list-item
        class="status"
        :key="item.id"
        :class="orderClass(item)"
        :to="{
          name: 'order-details',
          params: { groupId: item.groupId, orderId: item.orderId }
        }"
      >
        <v-list-item-content style="min-width: 200px;">
          <v-list-item-title v-if="item.group && item.group.company">
            {{ item.group.company.name }}
          </v-list-item-title>
          <v-list-item-subtitle color="text--primary">
            {{ getReceiptTypeName(item.receipt.receiptType) }}
            <span v-if="item.receipt.correction"> (чек коррекции)</span>
            <span v-else-if="item.parentId"> (исправление)</span>
            <span v-else-if="item.number"> (заказ №{{ item.number }})</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <span
              :class="
                item.paymentAmountSigned >= 0 ? 'green--text' : 'red--text'
              "
            >
              {{ item.paymentAmountSigned | currency }}
              <v-icon
                small
                v-if="item.receipt.payment.ecash"
                title="безналичная оплата"
                >mdi-credit-card-outline</v-icon
              >
            </span>
            &mdash;
            {{ productNames(item) }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-list-item-action-text class="datetime">
            {{ (item.createdAt || item.accepted) | datetime }}
          </v-list-item-action-text>
          <v-list-item-action-text
            v-text="
              (item.registrationInfo && item.registrationInfo.cashierName) ||
                (item.cashier && item.cashier.name)
            "
          />
          <v-list-item-action-text class="status">
            {{ statusName(item) }}
          </v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
    </template>
  </v-list>
</template>
<script>
import { getReceiptTypeName } from "@/datastore/enums";
import join from "lodash/join";
export default {
  name: "OrderList",
  props: ["items"],
  data() {
    return {};
  },
  methods: {
    getReceiptTypeName,
    orderClass(item) {
      let cls = item.status;
      /*
      if (item.parentId) {
        cls += " corrected";
      }
      */
      return cls;
    },
    statusName(item) {
      return item.statusName;
    },
    productNames(item) {
      return join(item.receipt.products.map(product => product.name), ", ");
    }
  }
};
</script>
<style scoped>
.created .status {
  color: blue;
}
.failed .status,
.unknown .status {
  color: red;
}
.accepted .status {
  color: orange;
}
.processed .status {
  color: green;
}
.processed .datetime {
}
.corrected {
  opacity: 0.5;
}
</style>
